import templateMain from "./views/published-main.html";
import typeOneHfYTemplate from "./views/reports-published/type-1-hf.html";
import periodicTestDeafaultHFTemplate from "./views/reports-published//periodic-test-hf.html";
import periodicTestDeafaultANNUALTemplate from "./views/reports-published//periodic-test-annual.html";
import defaultYearEndTemplate from "./views/reports-published//default-year-end.html";
import skilSubSkillTemplate from "./views/reports-published//skill-subskill.html";
import educoreYearEndTemplate from "./views/reports-published//educore-year-end.html";
import assetHFTemplate from "./views/reports-published//type-4-mark.html";
import assetAnnualemplate from "./views/reports-published//type-4-annual.html";
import termConsolidatedTemplate from "./views/reports-published//term1-term2.html";
import pTPublishedDefaultHFTwoTemplate from "./views/reports-published//periodic-test-hf-2.html";
import periodicTestDefaultAnnualTwoTemplate from "./views/reports-published//periodic-test-annual-two.html";
import kbTermsTemplate from "./views/reports-published//kb-terms.html";
import kgTermsTemplate from "./views/reports-published//kg-terms.html";
import kgConsolidatedTemplate from "./views/reports-published//kg-consolidated.html";
import hssTemplate from "./views/reports-published//hss-template.html";
import cbsehssTemplate from "./views/reports-published//cbse_hss.html";
import specificHalfYearlyTemplate from "./views/reports-published//term1halfyearly.html";
import kb_hf_hssTemplate from "./views/reports-published/kbhfhss.html";
import cbseSpecificSubjectsFinalTemplate from "./views/reports-published/grade-9-annual.html";
import grade1_8AnnTemplate from "./views/reports-published/grade-1_8-annual.html";
import kbfinalTemplate from "./views/reports-published/kb_final.html";
import annualcbsehssTemplate from "./views/reports-published/annual_cbse_hss.html";
import nineAnnualOnlyTemplate from "./views/reports-published/term-annual-only.html";
import kb_hss_annualTemplate from "./views/reports-published/kb_hss_annual.html";
import montessoryTermsTemplate from "./views/reports-published/montessory-terms.html";
import montessoryConsolidateTemplate from "./views/reports-published/montessory-consolidated.html";
import pTHFKb_Template from "./views/reports-published/periodic-test-hf-kb.html";
import publishedHFEXAM_CALICUT_Template from "./views/reports-published/hf1-exam.html";

import publishedType5_9_10_template from "./views/reports-published/type5_9_10_grade_term1.html";
import publishedType5_KB_10_template from "./views/reports-published/type5_KB_10_grade_term2.html";


import publishedType5_1_5_template from "./views/reports-published/type5_1_5_grade_term2.html";
import publishedType5_8_9_template from "./views/reports-published/type5_KB_8_9_grade_term3.html";

import publishedtype_6modelexam1_template from "./views/reports-published/type_6_model_exam_1.html";
import publishedtypetype_6_model_exam_1nineten_template from "./views/reports-published/type_6_model_exam_1_nineten.html";
import publishedtypetype_6_model_exam_IInineten_template from "./views/reports-published/type_6_model_exam_2_nineten.html";
import publishedtype_6modelexam2_template from "./views/reports-published/type_6_model_exam_2.html";
import publishedtype_6modelannualexam2_template from "./views/reports-published/type_6_model_annualexam_2.html";

import publishedtype_seven_calicut_annual from "./views/reports-published/calicut_annual.html";
import kgthematictermsTemplate from "./views/reports-published/kg-thematicterms.html";

import type9cbse11Template from "./views/reports-published/type9_term1_hf.html";
import type9_cbse_pt1Template from "./views/reports-published/type9_cbse_pt1.html";
import type9_grade12term2_aeTemplate from "./views/reports-published/type9_grade12term2_ae.html";
import type9_kb_unit_test1_template from "./views/reports-published/type9_kb_unit_test1.html";
import type9_kbterm3_template from "./views/reports-published/type9_kbterm3.html";
import type12_termcbseTemplate from "./views/reports-published/type12_termcbse.html";

import publishedTypeTwelveNineTenTemplate from "./views/reports-published/type12_ninetentermcbse.html";
import eltReportTemplate from "./views/reports-published/elt_report.html";
import type20_KB_10_grade_term1Temp from "./views/reports-published/type20_KB_10_grade_term1.html";
import type20_termcbseTemplate from "./views/reports-published/type20_termcbse.html";
import type20_termcbse18Template from "./views/reports-published/type20_termcbse18.html";
import type20_KB_10_grade_term2Temp from "./views/reports-published/type20_KB_10_grade_term2.html";
import type20_term2cbseTemplate from "./views/reports-published/type20_term2cbse.html";
import type20_term2cbse18Template from "./views/reports-published/type20_term2cbse18.html";
import type8to10_termcbseTemplate from "./views/reports-published/type8to10_termcbse.html";
import typetermcbse_8to10Template from "./views/reports-published/typetermcbse_8to10.html";
import type6to7_alncbseTemplate from "./views/reports-published/type6to7_alncbse.html";
import type6to7_tcscbseTemplate from "./views/reports-published/type6to7_tcscbse.html";
import type3to5_tcscbseTemplate from "./views/reports-published/type3to5_tcscbse.html";
import type3to5_alncbseTemplate from "./views/reports-published/type3to5_alncbse.html";
import type1to2_tcscbseTemplate from "./views/reports-published/type1to2_tcscbse.html";
import publishedType5_6_8_template from "./views/reports-published/type5_6_8_grade_term1.html";
import publishedType5_6_7_template from "./views/reports-published/type5_6_7_grade_term1.html";
import publishedType6_1_2_template from "./views/reports-published/type6_1_2_grade_term1.html";
import publishedType6_6_7_template from "./views/reports-published/type6_6_7_grade_term1.html";
import publishedType6_3_5_template from "./views/reports-published/type6_3_5_grade_term1.html";
import publishedType5_1_2_template from "./views/reports-published/type5_1_2_grade_term1.html";
import publishedType5_3_5_template from "./views/reports-published/type5_3_5_grade_term1.html";
import publishedType5_8_template from "./views/reports-published/type5_8_grade_term1.html";
import publishedType7_1_2_template from "./views/reports-published/type7_1_2_grade_term1.html";
import type30_KB_8_9_grade_term3Template from './views/reports-published/type30_KB_8_9_grade_term3.html'
import type10_KB_10_grade_term1Template from './views/reports-published/type10_KB_grade_term1.html'
import type10_KB_11_12_grade_term1Template from './views/reports-published/type10_KB_grade11_12_term1.html'
import type02grade_11_scienceTemplate from './views/reports-published/type02grade_11_science.html'
import type02grade_12_scienceTemplate from './views/reports-published/type02grade_12_science.html'
import pt_1_no_convTemplate from './views/reports-published/pt_1_no_conv.html';
import term1TemplatepublishedType5_3_5_template from "./views/reports-published/term1Templates/type5_3_5_grade_term1.html";
import term1TemplatepublishedType6_6_7_template from "./views/reports-published/term1Templates/type6_6_7_grade_term1.html";
import term1TemplatepublishedType8_9template from "./views/reports-published/term1Templates/type8to10_termcbse.html";
import term1TemplatepublishedType1_2template from "./views/reports-published/term1Templates/type5_1_2_grade_term1.html";

const name = "reportsMainComponent";
class PublishedReportsListCtrl {
	constructor( $scope,
		$state,
		$rootScope,
		$stateParams,
		$mdDialog,
		$sce,
		CONSTANTS,
		localStorageService,
		authService,
		rcConstants,
		RC_CONSTANTS_
	) {
		"ngInject";
		$rootScope.attendance_save_not = false;
		let self = this;
		$scope.loading = true;
		$scope.typeOneHF = false;
		$scope.typeOneGrade = false;
		$scope.typeTwoMark = false;
		$scope.typeThreeSubSkill = false;
		$scope.assetHF = false;
		$scope.assetAnnual = false;
		$scope.term1term2 = false;
		$scope.defaultPtHfTwo = false;
		$scope.defaultPtAnnualTwo = false;
		$scope.gradeNineFinal = false;
		$scope.publishedoneeight = false;
		$scope.attendance = undefined;
		$scope.mepStatic = false;
		$scope.annualKbTemp = false;
		$scope.montessoryTerms = false;
		$scope.montessoryConsolidate = false;
		$scope.ptHfKbPublished = false;
		$scope.hfExamOne = false;

		$scope.publishedType5_9_10 = false;
		$scope.publishedType5_KB_10 = false;
		$scope.type5_6_8_grade_terms = false;
		$scope.type5_6_7_grade_terms = false;

		$scope.type6_6_7_grade_terms = false;
		$scope.type6_3_5_grade_terms = false;

		$scope.type5_3_5_grade_terms = false;
		$scope.type5_8_grade_terms = false;
		$scope.type5_1_5_grade_terms = false;
		$scope.type6_1_2_grade_terms = false;
		$scope.type5_1_2_grade_terms = false;
		$scope.type5_KB_8_9_grade_term3 = false;

		$scope.type6_modelExamOne = false;
		$scope.type_6_model_exam_1_nineten = false;
		$scope.type_6_model_exam_II_nineten = false;
		$scope.type6_modelExamTwoNospace = false;
		$scope.type6_modelAnnualExamTerm = false;

		$scope.kgthematictermsFlag = false;
		$scope.publishedtype_seven_calicut_annual = false;
		$scope.type9_cbse_pt1 = false;
		$scope.type9_term1_hf = false;
		$scope.type9_grade12term2_ae = false;
		$scope.type9_kb_unit_test1 = false;
		$scope.type9_kbterm3 = false;
		$scope.publishedTypeTwelveOneEight = false;
		$scope.type12_ninetentermcbse = false;
		$scope.elt_report = false;
		$scope.type20_KB_10_grade_term = false;
		$scope.publishedTypeTwentyNineTen = false;
		$scope.publishedTypeTwentyOneEight = false;
		$scope.publishedTypeTwentyTwoNineTen = false;
		$scope.publishedTypeTwentyOneEightTwo = false;
		$scope.publishedTypeEightToTen = false;
		$scope.publishedTypeEightToTen2 = false;
		$scope.publishedTypeSixToSeven = false;
		$scope.publishedTypeSixToSeven2 = false;
		$scope.publishedTypeThreeToFive = false;
		$scope.publishedTypeThreeToFive2 = false;
		$scope.publishedTypeOneToTwo = false;
		$scope.PublishedTypesevenOneTwo = false;
		$scope.publishedType30KB78 = false
		$scope.publishedType10KB = false
		$scope.publishedType10KBElevenTwelve = false
		$scope.publishedTypeElevenScience = false
		$scope.publishedTypeTwelveScience = false
		$scope.T1type5_3_5_grade_terms = false
		$scope.T1type6_6_7_grade_terms = false
		$scope.T1type8_9_grade_terms = false
		$scope.T1type1_2_grade_terms = false
		$scope.pt_1_no_conv = false;
		let classTeacher = localStorageService.get("classTeacherRole");
		if (classTeacher == true) {
			$rootScope.isTeachingStaff = true;
		} else {
			$rootScope.isTeachingStaff = false;
		}
		let attendance_save_not = localStorageService.get(
			"attendance_save_not"
		);
		if (attendance_save_not) {
			$rootScope.attendance_save_not = true;
		}
		let school_id = localStorageService.get("school_id");
		if (!$stateParams.selected_year) {
			$state.go("dashboard");
		}
		let stuReportDataSub = undefined;

		this.$onInit = () => {
			//     console.log(localStorageService.get('parent_user_access','---------------------' )
			//    )
			$rootScope.isLoggedIn = localStorageService.get("is_login")
				? localStorageService.get("is_login")
				: false;
			if (!$rootScope.isLoggedIn) {
				$state.go("login", {}, { reload: true });
			}
			pushLog();
		};

		this.$onDestroy = () => {
			if (stuReportDataSub) stuReportDataSub.stop();
		};

		console.log(localStorageService.get("role_ids"));
		let requestBody = {
			studentId: $stateParams.student_id,
			rc_id: $stateParams.console_id,
			is_consolidated: $stateParams.type == "true" ? true : false,
			pdfFalg: false,
			school_id: school_id,
			template_view: $stateParams.template_view,
			asset_format: $stateParams.asset_format == "true" ? true : false,
			yearFromClient: $stateParams.selected_year,
			kb_consolidatedFlag:
				$stateParams.kb_consolidated == "true" ? true : false,
			forCT: classTeacher ? true : false,
			FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
			SITE_URL: CONSTANTS.SITE_URL,
			clientFileServer: CONSTANTS.FILE_UPLOAD_URL,
			kg_consolidated:
				$stateParams.kg_consolidated == "true" ? true : false,
			montessori_consolidated:
				$stateParams.montessori_consolidated == "true" ? true : false,
			is_web: true,
			parent_status:
				localStorageService
					.get("role_ids")
					.indexOf("Rt4ZwrDRxw8Zwer6aC") !== -1
					? true
					: false,
			student_status:
				localStorageService.get("role_ids").indexOf("student") !== -1
					? true
					: false,
		};
		function loadReport(requestBody, isSaveEvent = false) {
			console.log(requestBody, "requestBody");
			$rootScope.attendance = undefined;
			$rootScope.house = undefined;
			$rootScope.height = undefined;
			$rootScope.weight = undefined;
			$rootScope.bmi = undefined;
			$rootScope.working_days = undefined;
			$rootScope.selectedLevel = undefined;

			$rootScope.days_attended = undefined;
			$rootScope.term_remarks = undefined;
			$rootScope.attendance_term1 = undefined;

			$rootScope.attendance_term2 = undefined;
			$rootScope.lifeskillselection = undefined;
			$rootScope.attitudeselection=undefined;
			$rootScope.attitudeDataByIndex = undefined;
			$rootScope.lifeskillDataByIndex = undefined;
			$rootScope.attendance68_term1 = undefined;
			$rootScope.attendance68_term2 = undefined;
			$rootScope.attendanceKb89_term1 = undefined;
			$rootScope.attendanceKb89_term2 = undefined;
			$rootScope.attendanceKb89_term3 = undefined;
			$rootScope.attendanceKb10_term1 = undefined;
			$rootScope.attendanceKb10_term2 = undefined;
			$rootScope.StdResult = undefined;
			$rootScope.StdPromotGrade = undefined;
			$rootScope.StdReportDate = undefined;
			$rootScope.term_remarks1 = undefined;
			$rootScope.promoted_to = undefined;
			$rootScope.term_remarks2 = undefined;
			$rootScope.attitudeselction = undefined;
			$rootScope.lifeskillselction = undefined;
			$rootScope.attendancetenKb10_term1 = undefined;
			$rootScope.attendancetenKb10_term2 = undefined;
			$rootScope.published_date = undefined;
			authService.callAPI(
				"/v0/reportcards/published/getReportCardPublished",
				"POST",
				{ args: requestBody },
				function (response) {
					try {
						let result = response.result.data.details.response;
						console.log(result);
						console.log(response, "iiiiiiiiiiiiiiii");
						if (!result.error) {
							if (isSaveEvent) {
								toastr.success("Report Saved successfully");
							}
							if (result.attendance) {
								$rootScope.attendance = result.attendance;
							}
							if (result.extra_info) {
								if (result.extra_info.house) {
									$rootScope.house = result.extra_info.house;
								}
								if (result.extra_info.height) {
									$rootScope.height =
										result.extra_info.height;
								}
								if (result.extra_info.weight) {
									$rootScope.weight =
										result.extra_info.weight;
								}
								if (result.extra_info.bmi) {
									$rootScope.bmi = result.extra_info.bmi;
								}
								if (result.extra_info.working_days) {
									$rootScope.working_days =
										result.extra_info.working_days;
								}
								if (result.extra_info.days_attended) {
									$rootScope.days_attended =
										result.extra_info.days_attended;
								}
								if (result.extra_info.attendance_term1) {
									$rootScope.attendance_term1 =
										result.extra_info.attendance_term1;
								}
								if (result.extra_info.attendance_term2) {
									$rootScope.attendance_term2 =
										result.extra_info.attendance_term2;
								}
								if (result.extra_info.attendance68_term1) {
									$rootScope.attendance68_term1 =
										result.extra_info.attendance68_term1;
								}

								if (result.extra_info.attendance68_term2) {
									$rootScope.attendance68_term2 =
										result.extra_info.attendance68_term2;
								}
								if (result.extra_info.attendanceKb89_term1) {
									$rootScope.attendanceKb89_term1 =
										result.extra_info.attendanceKb89_term1;
								}
								if (result.extra_info.attendanceKb89_term2) {
									$rootScope.attendanceKb89_term2 =
										result.extra_info.attendanceKb89_term2;
								}
								if (result.extra_info.attendanceKb89_term3) {
									$rootScope.attendanceKb89_term3 =
										result.extra_info.attendanceKb89_term3;
								}
								if (result.extra_info.attendanceKb10_term1) {
									$rootScope.attendanceKb10_term1 =
										result.extra_info.attendanceKb10_term1;
								}
								if (result.extra_info.attendanceKb10_term2) {
									$rootScope.attendanceKb10_term2 =
										result.extra_info.attendanceKb10_term2;
								}
								if (result.extra_info.StdResult) {
									$rootScope.StdResult =
										result.extra_info.StdResult;
								}
								if (result.extra_info.StdPromotGrade) {
									$rootScope.StdPromotGrade =
										result.extra_info.StdPromotGrade;
								}
								if (result.extra_info.StdReportDate) {
									$rootScope.StdReportDate =
										result.extra_info.StdReportDate;
								}
								if (result.extra_info.term_remarks1) {
									$rootScope.term_remarks1 =
										result.extra_info.term_remarks1;
								}
								if (result.extra_info.promoted_to) {
									$rootScope.promoted_to =
										result.extra_info.promoted_to;
								}
								if (result.extra_info.term_remarks2) {
									$rootScope.term_remarks2 =
										result.extra_info.term_remarks2;
								}
								if (result.extra_info.attitudeselction) {
									$rootScope.attitudeselction =
										result.extra_info.attitudeselction;
								}
								if (result.extra_info.lifeskillselction) {
									$rootScope.lifeskillselction =
										result.extra_info.lifeskillselction;
								}if (result.extra_info.lifeskillselection) {
									$rootScope.lifeskillselection =
										result.extra_info.lifeskillselection;
								}if (result.extra_info.attitudeselection) {
									$rootScope.attitudeselection =
										result.extra_info.attitudeselection;
								}if (result.extra_info.attitudeDataByIndex) {
									$rootScope.attitudeDataByIndex =
										result.extra_info.attitudeDataByIndex;
								}if (result.extra_info.lifeskillDataByIndex) {
									$rootScope.lifeskillDataByIndex =
										result.extra_info.lifeskillDataByIndex;
								}if (result.extra_info.attendancetenKb10_term1) {
									$rootScope.attendancetenKb10_term1 =
										result.extra_info.attendancetenKb10_term1;
								}if (result.extra_info.attendancetenKb10_term2) {
									$rootScope.attendancetenKb10_term2 =
										result.extra_info.attendancetenKb10_term2;
								}
							}
							if (result.term_remarks) {
								$rootScope.term_remarks = result.term_remarks;
							}
							console.log(result.header)
							if(result.header && result.header.published_date){
								console.log(result.header.published_date)
								$rootScope.published_date = result.header.published_date
							}
							$scope.urls = result.pdf_data;
							if (result.report_card_template) {
								switchTemplate(
									result.report_card_template.template,result.is_term1
								);
							}
							// $scope.urls = CONSTANTS.FILE_UPLOAD_URL +
							// "/uploads/academic_reports/"+$stateParams.student_id+"/"+result.pdf_url
							self.reportCardArray = result;
							if (
								result.report_card_template &&
								result.report_card_template.template ==
									rcConstants.TYPE_3_SUB_SLILL
							) {
								self.reportCardArray = result.reportCardArray;
								$scope.reportCardArray = result.reportCardArray;
							}
							console.log("THE REPORT CARD DATA IS : ", self.reportCardArray);
							
						} else {
							toastr.error(result.error.message);
							window.history.back();
						}
						$scope.loading = false;
						_.defer(function () {
							$scope.$apply();
						});
					} catch (e) {
						toastr.error(e);
						$scope.loading = false;
						console.log(e);
					}
				}
			);
		}
		if ($stateParams.student_id && school_id) {
			console.log("KKKKk",requestBody
			)
			loadReport(requestBody);
		}
		self.saveAttendace = () => {


			if ($rootScope.attendance) {
				if (
					isNaN($rootScope.attendance) ||
					$rootScope.attendance > 100
				) {
					toastr.error("Please enter attendance in percentage");
					return false;
				}
			}
			// if($rootScope.term_remarks){

			//     var re = /^[ A-Za-z0-9_@./#&+-]*$/
			//     if (!re.test($rootScope.term_remarks)) {
			//         toastr.error('Will not accept a special character');
			//         return false;
			//     }
			// }
			$scope.loading = true;
			$scope.typeOneHF = false;
			$scope.typeOneGrade = false;
			$scope.typeTwoMark = false;
			$scope.typeThreeSubSkill = false;
			$scope.assetHF = false;
			$scope.assetAnnual = false;
			$scope.term1term2 = false;
			$scope.defaultPtHfTwo = false;
			$scope.defaultPtAnnualTwo = false;
			$scope.gradeNineFinal = false;
			$scope.publishedoneeight = false;
			$scope.attendance = undefined;
			$scope.Kb_Term = false;
			$scope.annualKbTemp = false;
			$scope.type6_modelExamOne = false;
			$scope.type_6_model_exam_1_nineten = false;
			$scope.type_6_model_exam_II_nineten = false;
			$scope.type6_modelExamTwoNospace = false;
			$scope.type6_modelAnnualExamTerm = false;

			$scope.publishedtype_seven_calicut_annual = false;
			$scope.kgthematictermsFlag = false;

			$scope.type9_term1_hf = false;
			$scope.type9_cbse_pt1 = false;
			$scope.type9_grade12term2_ae = false;
			$scope.type9_kb_unit_test1 = false;
			$scope.type9_kbterm3 = false;
			$scope.publishedTypeTwelveOneEight = false;
			$scope.type12_ninetentermcbse = false;
			$scope.elt_report = false;
			$scope.type20_KB_10_grade_term = false;
			self.reportCardArray = undefined;
			$scope.publishedTypeTwentyNineTen = false;
			$scope.publishedTypeTwentyOneEight = false;
			$scope.publishedType30KB78 = false
			$scope.pt_1_no_conv = false
			requestBody["term_remarks"] = $rootScope.term_remarks;
			requestBody["attendance"] = $rootScope.attendance;
			requestBody["term_remarks1"] = $rootScope.term_remarks1;
			requestBody["promoted_to"] = $rootScope.promoted_to;
			$scope.selectedValues = [];

			// Function to store the selected value
			$scope.storeSelectedValue = function (index) {
				$scope.selectedValues[index] = $scope.selectedLevel[index];
				console.log("Selected value:", $scope.selectedValues[index]);
			};
			let extra_info = {};
			if ($rootScope.house) {
				extra_info.house = $rootScope.house;
			}
			if ($rootScope.height) {
				extra_info.height = $rootScope.height;
			}
			if ($rootScope.weight) {
				extra_info.weight = $rootScope.weight;
			}
			if ($rootScope.bmi) {
				extra_info.bmi = $rootScope.bmi;
			}
			if ($rootScope.working_days) {
				extra_info.working_days = $rootScope.working_days;
			}
			if ($rootScope.selectedLevel) {
				extra_info.selectedLevel = $rootScope.selectedLevel;
			}
			if ($rootScope.days_attended) {
				extra_info.days_attended = $rootScope.days_attended;
			}
			if ($rootScope.attendance_term1) {
				extra_info.attendance_term1 = $rootScope.attendance_term1;
			}
			if ($rootScope.attitudeselction) {
				extra_info.attitudeselction = $rootScope.attitudeselction;
			}
			if ($rootScope.lifeskillselction) {
				extra_info.lifeskillselction = $rootScope.lifeskillselction;
			}

			if ($rootScope.attendance_term2) {
				extra_info.attendance_term2 = $rootScope.attendance_term2;
			}
			if ($rootScope.attendance68_term1) {
				extra_info.attendance68_term1 = $rootScope.attendance68_term1;
			}
			if ($rootScope.lifeskillselection) {
				extra_info.lifeskillselection = $rootScope.lifeskillselection;
			}if ($rootScope.attitudeselection) {
				extra_info.attitudeselection = $rootScope.attitudeselection;
			}if ($rootScope.attitudeDataByIndex) {
				extra_info.attitudeDataByIndex = $rootScope.attitudeDataByIndex;
			}if ($rootScope.lifeskillDataByIndex) {
				extra_info.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex;
			}

			// if ($rootScope.selectedDescription1) {
			// 	extra_info.selectedDescription1 =
			// 		$rootScope.selectedDescription1;
			// }
			// if ($rootScope.selectedDescription2) {
			// 	extra_info.selectedDescription2 =
			// 		$rootScope.selectedDescription2;
			// }
			// if ($rootScope.selectedDescription3) {
			// 	extra_info.selectedDescription3 =
			// 		$rootScope.selectedDescription3;
			// }
			// if ($rootScope.selectedDescription4) {
			// 	extra_info.selectedDescription4 =
			// 		$rootScope.selectedDescription4;
			// }
			// if ($rootScope.selectedDescription5) {
			// 	extra_info.selectedDescription5 =
			// 		$rootScope.selectedDescription5;
			// }
			// if ($rootScope.selectedDescription6) {
			// 	extra_info.selectedDescription6 =
			// 		$rootScope.selectedDescription6;
			// }
			// if ($rootScope.selectedDescription7) {
			// 	extra_info.selectedDescription7 =
			// 		$rootScope.selectedDescription7;
			// }
			// if ($rootScope.selectedDescription8) {
			// 	extra_info.selectedDescription8 =
			// 		$rootScope.selectedDescription8;
			// }
			// if ($rootScope.selectedDescription9) {
			// 	extra_info.selectedDescription9 =
			// 		$rootScope.selectedDescription9;
			// }
			// if ($rootScope.selectedDescription10) {
			// 	extra_info.selectedDescription10 =
			// 		$rootScope.selectedDescription10;
			// }
			// if ($rootScope.selectedDescription11) {
			// 	extra_info.selectedDescription11 =
			// 		$rootScope.selectedDescription11;
			// }
			// if ($rootScope.selectedDescription12) {
			// 	extra_info.selectedDescription12 =
			// 		$rootScope.selectedDescription12;
			// }
			// if ($rootScope.selectedDescription13) {
			// 	extra_info.selectedDescription13 =
			// 		$rootScope.selectedDescription13;
			// }
			// if ($rootScope.selectedDescription14) {
			// 	extra_info.selectedDescription14 =
			// 		$rootScope.selectedDescription14;
			// }
			if ($rootScope.attendance68_term2) {
				extra_info.attendance68_term2 = $rootScope.attendance68_term2;
			}
			if ($rootScope.attendanceKb89_term1) {
				extra_info.attendanceKb89_term1 =
					$rootScope.attendanceKb89_term1;
			}
			if ($rootScope.attendanceKb89_term2) {
				extra_info.attendanceKb89_term2 =
					$rootScope.attendanceKb89_term2;
			}
			if ($rootScope.attendanceKb89_term3) {
				extra_info.attendanceKb89_term3 =
					$rootScope.attendanceKb89_term3;
			}
			if ($rootScope.attendanceKb10_term1) {
				extra_info.attendanceKb10_term1 =
					$rootScope.attendanceKb10_term1;
			}
			if ($rootScope.attendanceKb10_term2) {
				extra_info.attendanceKb10_term2 =
					$rootScope.attendanceKb10_term2;
			}
			if ($rootScope.StdResult) {
				extra_info.StdResult = $rootScope.StdResult;
			}
			if ($rootScope.StdPromotGrade) {
				extra_info.StdPromotGrade = $rootScope.StdPromotGrade;
			}
			if ($rootScope.StdReportDate) {
				extra_info.StdReportDate = $rootScope.StdReportDate;
			}
			if ($rootScope.promoted_to) {
				extra_info.promoted_to = $rootScope.promoted_to;
			}
			if ($rootScope.term_remarks1) {
				extra_info.term_remarks1 = $rootScope.term_remarks1;
			}
			if ($rootScope.term_remarks2) {
				extra_info.term_remarks2 = $rootScope.term_remarks2;
			}if ($rootScope.attendancetenKb10_term1) {
				extra_info.attendancetenKb10_term1 =
					$rootScope.attendancetenKb10_term1;
			}
			if ($rootScope.attendancetenKb10_term2) {
				extra_info.attendancetenKb10_term2 =
					$rootScope.attendancetenKb10_term2;
			}
			requestBody["extra_info"] = extra_info;
			$scope.loading = true;
			console.log(extra_info,"pppextra_info----++++++");
			loadReport(requestBody, true);
		};
		// self.subscribe('getReportCardDataThisStudent',authoring})
		// stuReportDataSub = self.subscribe("getReportCardDataThisStudent", () => [$stateParams.student_id, $stateParams.selected_year])
		// if($stateParams.student_id && school_id){
		//     let rc = ReportCardData.find({}).fetch()
		// 	Meteor.call("getReportCardPublished",$stateParams.student_id, $stateParams.console_id, $stateParams.type,
		//      false, school_id, $stateParams.template_view, $stateParams.asset_format,
		//      $stateParams.selected_year, $stateParams.kb_consolidated, $stateParams.for_ct,
		//      function(error, result) {
		// 		if(result){
		//             console.log(result)
		// 			// if(result){
		// 				if(result.report_card_template){
		// 					switchTemplate(result.report_card_template.template)

		// 				}
		//                 self.reportCardArray = result
		//                 if(result.report_card_template.template == TYPE_3_SUB_SLILL){
		//                     self.reportCardArray = result.reportCardArray
		//                     $scope.reportCardArray = result.reportCardArray
		//                 }

		// 			// }
		// 		}
		//         $scope.loading = false
		// 		_.defer(function() { $scope.$apply(); });;
		//     })
		// }

		function switchTemplate(template, isterm1 = false) {
			console.log(template);
			switch (template) {
				case rcConstants.TYPE_1_MARK:
					$scope.typeOneHF = true;
					break;
				case rcConstants.TYPE_1_GRADE:
					$scope.typeOneGrade = true;
					break;
				case rcConstants.TYPE_2_MARK:
					$scope.typeTwoMark = true;
					break;
				case rcConstants.TYPE_3_SUB_SLILL:
					$scope.typeThreeSubSkill = true;
					break;
				case rcConstants.TYPE_1_DEFAULT_ANNUAL:
					$scope.typeOneHF = true;
					break;
				case rcConstants.DEFAULT_PERIODICTEST_HF:
					$scope.defaultPtHf = true;
					break;
				case rcConstants.DEFAULT_PERIODICTEST_ANNUAL:
					$scope.defaultPtAnnual = true;
					break;
				case rcConstants.DEFAULT_YEAR_END:
					$scope.defaultYearEnd = true;
					break;
				case rcConstants.EDUCORE_YEAR_END:
					$scope.educoreYearEnd = true;
					break;
				case rcConstants.TYPE_4_MARK:
					$scope.type_four_mark = true;
					break;
				case rcConstants.TYPE_4_ANNUAL:
					$scope.type_four_annual = true;
					break;
				case rcConstants.ASSET_CONSOLIDATED:
					$scope.term1term2 = true;
					break;
				case rcConstants.DEFAULT_PERIODICTEST_HF_TWO:
					$scope.defaultPtHfTwo = true;
					break;
				case rcConstants.DEFAULT_PERIODICTEST_ANNUAL_TWO:
					$scope.defaultPtAnnualTwo = true;
					break;
				case rcConstants.KG_TERMS:
					$scope.Kg_Terms = true;
					break;
				case rcConstants.KG_CONSOLIDATED:
					$scope.Kg_Consolidated = true;
					break;
				case rcConstants.KB_TERMS:
					$scope.Kb_Terms = true;
					break;
				case rcConstants.HIGHER_SECONDARY_REPORT:
					$scope.hssTemplate = true;
					break;
				case rcConstants.CBSE_HSHF:
					$scope.cbsehss = true;
					break;
				case "term1halfyearly":
					$scope.term1halfyearly = true;
					break;
				case "grade-9-annual":
					$scope.gradeNineFinal = true;
					break;
				case rcConstants.KBHFHSS:
					$scope.KBHFHSSflag = true;
					break;
				case "grade-1_8-annual":
					$scope.publishedoneeight = true;
					break;
				case "kb_final":
					$scope.kb_finalFlag = true;
					break;
				case "annual_cbse_hss":
					$scope.cbseAnnualHss = true;
					break;
				case "term-annual-only":
					$scope.nineOnlyAnnual = true;
					break;
				case "kb_hss_annual":
					$scope.annualKbTemp = true;
					break;
				case rcConstants.MONTESSORY_TERMS:
					$scope.montessoryTerms = true;
					break;
				case rcConstants.MONTESSORY_CONSOLIDATED:
					$scope.montessoryConsolidate = true;
					break;
				case "periodic-test-hf-kb":
					$scope.ptHfKbPublished = true;
					break;
				case "hf1-exam":
					$scope.hfExamOne = true;
					break;
				case "type5_9_10_grade_term1":
					$scope.publishedType5_9_10 = true;
					break;
				case "type5_KB_10_grade_term2":
					$scope.publishedType5_KB_10 = true;
					break;
				case "type5_6_8_grade_term1":
					$scope.type5_6_8_grade_terms = true;
					break;
				case "type5_6_7_grade_term1":
					$scope.type5_6_7_grade_terms = true;
					break;

				case "type6_6_7_grade_term1":
					if(isterm1){
						$scope.T1type6_6_7_grade_terms = true
					}
					else{
						$scope.type6_6_7_grade_terms = true;
					}
					break;
				case "type6_3_5_grade_term1":
					$scope.type6_3_5_grade_terms = true;
					break;

				case "type5_3_5_grade_term1":
					if(isterm1){
						$scope.T1type5_3_5_grade_terms = true;
					}else{
						$scope.type5_3_5_grade_terms = true;
					}
					break;
				case "type5_8_grade_term1":
					$scope.type5_8_grade_terms = true;
					break;
				case "type5_1_5_grade_term2":
					$scope.type5_1_5_grade_terms = true;
					break;
				case "type6_1_2_grade_term1":
					$scope.type6_1_2_grade_terms = true;
					break;
				case "type5_1_2_grade_term1":
					if(isterm1){
						$scope.T1type1_2_grade_terms = true
					}else{
						$scope.type5_1_2_grade_terms = true;
					}
					break;
				case "type5_KB_8_9_grade_term3":
					$scope.type5_KB_8_9_grade_term3 = true;
					break;
				case "type_6_model_exam_1":
					$scope.type6_modelExamOne = true;
					break;
				case "type_6_model_exam_1_nineten":
					$scope.type_6_model_exam_1_nineten = true;
					break;
				case "type_6_model_exam_2_nineten":
					$scope.type_6_model_exam_II_nineten = true;
					break;
				case "type_6_model_exam_2":
					$scope.type6_modelExamTwoNospace = true;
					break;
				case "type_6_model_annualexam_2":
					$scope.type6_modelAnnualExamTerm = true;
					break;
				case "calicut_annual":
					$scope.publishedtype_seven_calicut_annual = true;
					break;
				case "kg-thematicterms":
					$scope.kgthematictermsFlag = true;
					break;
				case "type9_term1_hf":
					$scope.type9_term1_hf = true;
					break;
				case "type9_cbse_pt1":
					$scope.type9_cbse_pt1 = true;
					break;
				case "type9_grade12term2_ae":
					$scope.type9_grade12term2_ae = true;
					break;
				case "type9_kb_unit_test1":
					$scope.type9_kb_unit_test1 = true;
					break;
				case "type9_kbterm3":
					$scope.type9_kbterm3 = true;
					break;
				case "type12_termcbse":
					$scope.publishedTypeTwelveOneEight = true;
					break;
				case "type12_ninetentermcbse":
					$scope.type12_ninetentermcbse = true;
					break;
				case "elt-report":
					$scope.elt_report = true;
					break;
				case "type20_KB_10_grade_term1":
					$scope.type20_KB_10_grade_term = true;
					break;
				case "type20_termcbse":
					$scope.publishedTypeTwentyNineTen = true;
					break;
				case "type20_termcbse18":
					$scope.publishedTypeTwentyOneEight = true;
					break;
				case "type20_KB_10_grade_term2":
					$scope.type20_KB_10_grade_term2 = true;
					break;
				case "type20_term2cbse":
					$scope.publishedTypeTwentyTwoNineTen = true;
					break;
				case "type20_term2cbse18":
					$scope.publishedTypeTwentyOneEightTwo = true;
					break;
				case "type8to10_termcbse":
					if(isterm1){
						$scope.T1type8_9_grade_terms = true
					}
					else{
						$scope.publishedTypeEightToTen = true;
					}
					break;
				case "typetermcbse_8to10":
					$scope.publishedTypeEightToTen2 = true;
					break;
				case "type6to7_alncbse":
					$scope.publishedTypeSixToSeven = true;
					break;
				case "type6to7_tcscbse":
					$scope.publishedTypeSixToSeven2 = true;
					break;
				case "type3to5_tcscbse":
					$scope.publishedTypeThreeToFive = true;
					break;
				case "type3to5_alncbse":
					$scope.publishedTypeThreeToFive2 = true;
					break;
				case "type1to2_tcscbse":
					$scope.publishedTypeOneToTwo = true;
					break;
				case "type7_1_2_grade_term1":
					$scope.PublishedTypesevenOneTwo = true;
					break;
				case "type30_KB_8_9_grade_term3":
					$scope.publishedType30KB78 = true
					break;
				case "type10_KB_grade_term1":
					$scope.publishedType10KB = true
					break;
				case "type10_KB_grade11_12_term1":
					$scope.publishedType10KBElevenTwelve = true
					break;
				case "type02grade_11_science":
					$scope.publishedTypeElevenScience=true
					break;
				case "type02grade_12_science":
					$scope.publishedTypeTwelveScience=true
					break;
				case "pt_1_no_conv":
					$scope.pt_1_no_conv = true
					break;
			}
		}

		// $scope.set = (val) => {
		//     return array = JSON.parse(val)
		// }

		self.export = () => {
			$scope.loading = true;
			$scope.pdfData = true;
			$scope.url = $sce.trustAsResourceUrl($scope.urls);
			$scope.loading = false;
			_.defer(function () {
				$scope.$apply();
			});
		};

		self.backToHtml = () => {
			$scope.pdfData = false;
		};
		function pushLog() {
			let userIds = localStorageService.get("user_id");
			let schoolIds = localStorageService.get("school_id");
			var logData = requestBody.studentId + "_" + requestBody.rc_id;
			authService.callRabbitMQAPI(
				"/v0/rabbitmqpush_withlog/" +
					userIds +
					"/" +
					schoolIds +
					"/ReportCard_View/" +
					logData,
				"GET",
				{},
				function (response) {
					// console.log(response)
				}
			);
		}
	}
}

const typeOneHfYComponent = "typeOneHfComponent";
class TypeOneHfYTemplateClass {
	constructor(
		$scope,
		$state,
		$window,
		$stateParams,
		$mdDialog,
		$mdMedia,
		RC_CONSTANTS_,
		localStorageService
	) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			let school_id = localStorageService.get("school_id");
			if (
				RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS &&
				RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS.indexOf(school_id) !== -1
			) {
				vm.PORT_FOLIO_AS_NB_SCHOOLS = true;
			}
			vm.reportCardArray = this.typeOneHfYTemplateCtrl.reportCardArray;
			vm.buckets =
				this.typeOneHfYTemplateCtrl.reportCardArray.report_card_template.activity_buckets;
		};
		//  $scope.set = (val) => {
		//     return array = JSON.parse(val)
		// }

		// this.exportReportData = () => {
		// }
	}
}

const periodicTestDefaultHfPublished = "periodicTestDefaultHfPublished";
class PeriodicTestDefaultHfPublished {
	constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.pTPublishedDefauHlFCtrl.reportCardArray;
			vm.buckets =
				this.pTPublishedDefauHlFCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const periodicTestDefaultAnnualPublished = "periodicTestDefaultAnnualPublished";
class PeriodicTestDefaultAnnualPublished {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.pTPublishedDefaultAnnualCtrl.reportCardArray;
			vm.buckets =
				this.pTPublishedDefaultAnnualCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const defaultYearEnd = "defaultYearEnd";
class DefaultYearEnd {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.defaultYearEndCtrl.reportCardArray;
			vm.buckets =
				this.defaultYearEndCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const termConsolidated = "termConsolidated";
class TermConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.termConsolidatedCtrl.reportCardArray;
			vm.buckets =
				this.termConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}

const educoreYearEnd = "educoreYearEnd";
class EducoreYearEnd {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.educoreYearEndCtrl.reportCardArray;
			_.each(
				vm.reportCardArray.main_results,
				function (value, subjectName) {
					if (value.grade_1 == "A1") {
						value["color_1"] = "#d0a1f3";
					}
					if (value.grade_1 == "A2") {
						value["color_1"] = "#56bbec";
					}
					if (value.grade_1 == "B1") {
						value["color_1"] = "#93ca16";
					}
					if (value.grade_1 == "B2") {
						value["color_1"] = "#b7b6b1";
					}
					if (value.grade_1 == "C1") {
						value["color_1"] = "#e6c95a";
					}
					if (value.grade_1 == "C2") {
						value["color_1"] = "#d6aa00";
					}
					if (value.grade_1 == "D") {
						value["color_1"] = "#e2b60c";
					}
					if (value.grade_1 == "E") {
						value["color_1"] = "#f37404";
					}
					if (value.grade_1 == "NA") {
						value["color_1"] = "red";
					}
					if (value.grade_2 == "A1") {
						value["color_2"] = "#d0a1f3";
					}
					if (value.grade_2 == "A2") {
						value["color_2"] = "#56bbec";
					}
					if (value.grade_2 == "B1") {
						value["color_2"] = "#93ca16";
					}
					if (value.grade_2 == "B2") {
						value["color_2"] = "#b7b6b1";
					}
					if (value.grade_2 == "C1") {
						value["color_2"] = "#e6c95a";
					}
					if (value.grade_2 == "C2") {
						value["color_2"] = "#d6aa00";
					}
					if (value.grade_2 == "D") {
						value["color_2"] = "#e2b60c";
					}
					if (value.grade_2 == "E") {
						value["color_2"] = "#f37404";
					}
					if (value.grade_2 == "NA") {
						value["color_2"] = "red";
					}
				}
			);
			_.each(
				vm.reportCardArray.other_sections,
				function (value, subjectName) {
					if (value.grade_1 == "A") {
						value["color_1"] = "#d0a1f3";
					}
					if (value.grade_1 == "B") {
						value["color_1"] = "#93ca16";
					}
					if (value.grade_1 == "C") {
						value["color_1"] = "#e6c95a";
					}
					if (value.grade_1 == "NA") {
						value["color_1"] = "red";
					}
					if (value.grade_2 == "A") {
						value["color_2"] = "#d0a1f3";
					}
					if (value.grade_2 == "B") {
						value["color_2"] = "#93ca16";
					}
					if (value.grade_2 == "C") {
						value["color_2"] = "#e6c95a";
					}
					if (value.grade_2 == "NA") {
						value["color_2"] = "red";
					}
				}
			);
			vm.buckets =
				this.educoreYearEndCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}

const skilSubSkill = "skilSubSkill";
class SkilSubSkill {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.skilSubSkillCtrl.reportCardArray;
			$scope.reportCardArray = this.skilSubSkillCtrl.reportCardArray;
			// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
		};
	}
}
const assetHF = "assetHfComponent";
class AssetHF {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.assetHFCtrl.reportCardArray;
			$scope.reportCardArray = this.assetHFCtrl.reportCardArray;
			// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
		};
	}
}
const assetAnnual = "assetAnnualComponent";
class AssetAnnual {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.assetAnnualCtrl.reportCardArray;
			$scope.reportCardArray = this.assetAnnualCtrl.reportCardArray;
			// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
		};
	}
}
const kgTerms = "kgTerms";
class KgTerms {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.kgTermsCtrl.reportCardArray;
			$scope.reportCardArray = this.kgTermsCtrl.reportCardArray;
			console.log($scope.reportCardArray.main_results);
			console.log(">>>>>>>>>>");
			vm.evaluations = vm.reportCardArray.response.evals;
			vm.resultValues = vm.reportCardArray.reportCardArray.main_results;
			console.log(vm.reportCardArray);
		};
		// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
	}
}
const periodicTestDefaultHfTwoPublished = "periodicTestDefaultHfTwoPublished";
class PeriodicTestDefaultHfTwoPublished {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.pTPublishedHfTwoCtrl.reportCardArray;
			vm.buckets =
				this.pTPublishedHfTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const periodicTestDefaultAnnualTwoPublished =
	"periodicTestDefaultAnnualTwoPublished";
class PeriodicTestDefaultAnnualTwoPublished {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.pTPublishedDefaultAnnualTwoCtrl.reportCardArray;
			vm.buckets =
				this.pTPublishedDefaultAnnualTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const kgConsolidated = "kgConsolidated";
class KgConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.kgConsolidatedCtrl.reportCardArray;
			vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
			vm.reportResultArray =
				vm.reportCardArray.reportCardArray.main_result_report;
			console.log(vm.reportResultArray);
		};
	}
}
const kbTerms = "kbTerms";
class KbTerms {
	constructor($scope, $state, $window, localStorageService, rcConstants) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;

		this.$onInit = function () {
			vm.reportCardArray = this.kbTermsCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
			if (
				rcConstants.MEP_STATIC_SCHOOL_IDS.indexOf(
					localStorageService.get("school_id")
				) !== -1
			) {
				if (vm.reportCardArray.header.report_name == "KB-Term-3") {
					$scope.mepStatic = true;
				}
			}
		};
	}
}
const hssTemplateComponent = "hssComponent";
class HssTemplateComponentClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.hssReportCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const cbseHssPublishedComponent = "cbseHssPublishedComponent";
class CbseHssPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.cbseHssPublishedCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const specificHFComponent = "specificHf";
class SpecificHFPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.specificHFPublishedCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const kbhfhssComp = "kbhfhsspublishedComp";
class KbhfhssPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.KbhfhssPublishedCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const cbseSpecificoneeigthFinalComp = "cbseSpecificoneeigthFinalComp";
class CbseSpecificoneeigthFinalClass {
	constructor($scope, rcConstants, localStorageService) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;

		/** Added to check the school ids for not showing final */
		$scope.nonFinalSchoolIds = !rcConstants.NON_FINAL_SCHOOL_IDS.includes(
			localStorageService.get("school_id")
		);

		this.$onInit = function () {
			vm.reportCardArray =
				this.cbseSpecificoneeghtFinalCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const cbseSpecificSubjectsFinalComp = "cbseSpecificSubjectsFinalComp";
class CbseSpecificSubjectsFinalClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.cbseSpecificSubjectsFinalCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const kbFinalComponent = "kbFinalComponent";
class kbFinalComponentClass {
	constructor(
		$scope,
		$state,
		$window,
		$stateParams,
		localStorageService,
		rcConstants
	) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		if (
			rcConstants.MEP_STATIC_SCHOOL_IDS.indexOf(
				localStorageService.get("school_id")
			) !== -1
		) {
			$scope.mepStatic = true;
		}
		this.$onInit = function () {
			vm.reportCardArray = this.kbFinalComponentCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
			console.log(vm.reportCardArray);
		};
	}
}
const pubishedcbsehssAnnual = "pubishedcbsehssAnnual";
class PubishedcbsehssAnnual {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";

		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.pubishedcbsehssAnnualCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
			console.log(vm.reportCardArray);
		};
	}
}
const nineonlypubllishedComp = "nineonlypubllishedComp";
class NineonlypubllishedCompClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.nineonlypubllishedCompCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const kbannualHssPublished = "kbannualHssPublished";
class KbannualHssPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.allStudentReportData = undefined;
		vm.card_details = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.kbannualHssPublishedCtrl.reportCardArray;
			vm.reportCardArray = vm.reportCardArray;
		};
	}
}
const montessoryTerms = "montessoryTerms";
class montessoryTermsPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.montessoryTermsPublishedCtrl.reportCardArray;
			$scope.reportCardArray = this.montessoryTermsPublishedCtrl.reportCardArray;
			console.log($scope.reportCardArray.main_results);
			vm.evaluations = vm.reportCardArray.response.evals;
			vm.resultValues = vm.reportCardArray.reportCardArray.main_results;
			console.log(vm.reportCardArray);
		};
	}
}
const montessoryConsolidated = "montessoryConsolidated";
class montessoryConsolidatedPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.montessoryConsolidatedPublishedCtrl.reportCardArray;
			vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
			console.log(vm.reportCardArray);
		};
	}
}

const kbhfPtPublishedComponent = "kbhfPtPublishedComponent";
class KbhfPtPublishedPublishedClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.kbhfPtPublishedPublishedCtrl.reportCardArray;
			vm.buckets =
				this.kbhfPtPublishedPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const hfexamOnePublishedComponent = "hfexamOnePublishedComponent";
class HfexamOnePublishedComponentClass {
	constructor(
		$scope,
		$state,
		$rootScope,
		$window,
		$stateParams,
		$mdDialog,
		$mdMedia
	) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.hfexamOnePublishedCtrl.reportCardArray;
			vm.buckets =
				this.hfexamOnePublishedCtrl.reportCardArray.report_card_template.activity_buckets;
		};
		//  $scope.set = (val) => {
		//     return array = JSON.parse(val)
		// }

		// this.exportReportData = () => {
		// }

		self.calbmi = () => {
			console.log($rootScope.height + "  " + $rootScope.weight);
			var cc = Number($rootScope.height) * Number($rootScope.height);
			var bmiVal =
				(Number($rootScope.weight) /
					Number($rootScope.height) /
					Number($rootScope.height)) *
				Number(10000);
			$rootScope.bmi = Math.round(bmiVal);
			$scope.$apply();
			console.log(bmiVal);
		};
		self.calatt = () => {
			console.log(
				$rootScope.working_days + "  " + $rootScope.days_attended
			);
			var attVal =
				(Number($rootScope.days_attended) /
					Number($rootScope.working_days)) *
				Number(100);
			$rootScope.attendance_term1 = Math.round(attVal);
			$scope.$apply();
			console.log(attVal);
		};
	}
}
const publishedCbseTypefiveNineTen = "publishedCbseTypefiveNineTen";
class PublishedCbseTypefiveNineTenClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedCbseTypefiveNineTenCtrl.reportCardArray;
			vm.buckets =
				this.publishedCbseTypefiveNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeFiveKbten = "publishedTypeFiveKbten";
class PublishedTypeFiveKbtenClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeFiveKbtenCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeFiveKbtenCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeFiveSixEight = "publishedTypeFiveSixEight";
class PublishedTypeFiveSixEight {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeFiveSixEightCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeFiveSixEightCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeFiveOneFive = "publishedTypeFiveOneFive";
class PublishedTypeFiveOneFive {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeFiveOneFiveCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeFiveOneFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeFiveKbEightNine = "publishedTypeFiveKbEightNine";
class PublishedTypeFiveKbEightNine {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeFiveKbEightNineCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeFiveKbEightNineCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeSixModalExamTermOne = "publishedTypeSixModalExamTermOne";
class PublishedTypeSixModalExamTermOne {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeSixModalExamTermOneCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeSixModalExamTermOneCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const typesixModelExamTermOneninetenPublished =
	"publishedTypesixModelExamNineTen";
class TypesixModelExamTermOneninetenPublished {
	constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.typesixModelExamTermOneninetenPublishedCtrl.reportCardArray;
			vm.buckets =
				this.typesixModelExamTermOneninetenPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const typesixModelExamTermTwoninetenPublished =
	"publishedTypesixModelExamNineTenTwo";
class TypesixModelExamTermTwoninetenPublished {
	constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray;
			vm.buckets =
				this.typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeSixModalExamTermTwonospace =
	"publishedTypeSixModalExamTermTwonospace";
class PublishedTypeSixModalExamTermTwonospace {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeSixModelannualexam = "publishedTypeSixModelannualexam";
class PublishedTypeSixModelannualexam {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeSixModelannualexamCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeSixModelannualexamCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeSevenCalicutAnnualexam =
	"publishedTypeSevenCalicutAnnualexam";
class PublishedTypeSevenCalicutAnnualexam {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const kgthematictermsComponent = "kgthematictermsComponent";
class KgthematictermsClass {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.kgthematictermsCtrl.reportCardArray;
			$scope.reportCardArray = this.kgthematictermsCtrl.reportCardArray;
			vm.evaluations = vm.reportCardArray.response.evals;
			console.log(vm.evaluations);
		};
	}
}
const typeNineCbseConsolidated = "typeNineCbseConsolidated";
class TypeNineCbseConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.typeNineCbseConsolidatedCtrl.reportCardArray;
			vm.buckets =
				this.typeNineCbseConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
			//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    vm.evaluations = vm.reportCardArray.response.evals
			//    console.log(vm.evaluations)
		};
	}
}
const typeNineCbsept = "typeNineCbsept";
class TypeNineCbsept {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.typeNineCbseptCtrl.reportCardArray;
			vm.buckets =
				this.typeNineCbseptCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const typeNineTwelveCbseConsolidated = "typeNineTwelveCbseConsolidated";
class TypeNineTwelveCbseConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.typeNineTwelveCbseConsolidatedCtrl.reportCardArray;
			vm.buckets =
				this.typeNineTwelveCbseConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
			//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    vm.evaluations = vm.reportCardArray.response.evals
			//    console.log(vm.evaluations)
		};
	}
}
const typeNinekbUnitTest = "typeNinekbUnitTest";
class TypeNinekbUnitTest {
	constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.typeNinekbUnitTestCtrl.reportCardArray;
			vm.buckets =
				this.typeNinekbUnitTestCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const typeNinekbConsolidated = "typeNinekbConsolidated";
class TypeNinekbConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.typeNinekbConsolidatedCtrl.reportCardArray;
			vm.buckets =
				this.typeNinekbConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
			//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
			//    vm.evaluations = vm.reportCardArray.response.evals
			//    console.log(vm.evaluations)
		};
	}
}
const publishedTypeTwelveOneEight = "publishedTypeTwelveOneEight";
class PublishedTypeTwelveOneEight {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwelveOneEightCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwelveOneEightCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeTwelveNineTen = "publishedTypeTwelveNineTen";
class PublishedTypeTwelveNineTen {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwelveNineTenCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwelveNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}

const publishedEltReport = "publishedEltReport";
class PublishedEltReport {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.publishedEltReportCtrl.reportCardArray;
			vm.buckets =
				this.publishedEltReportCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedType20kbterms = "publishedType20kbterms";
class PublishedType20kbterms {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedType20kbtermsCtrl.reportCardArray;
			vm.buckets =
				this.publishedType20kbtermsCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeTwentyNineTen = "publishedTypeTwentyNineTen";
class PublishedTypeTwentyNineTen {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwentyNineTenCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwentyNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeTwentyOneEight = "publishedTypeTwentyOneEight";
class PublishedTypeTwentyOneEight {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwentyOneEightCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwentyOneEightCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeTwentyNineTenTwo = "publishedTypeTwentyNineTenTwo";
class PublishedTypeTwentyNineTenTwo {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwentyNineTenTwoCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwentyNineTenTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeTwentyOneEightTwo = "publishedTypeTwentyOneEightTwo";
class PublishedTypeTwentyOneEightTwo {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypeTwentyOneEightTwoCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypeTwentyOneEightTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedType20kbterms2 = "publishedType20kbterms2";
class PublishedType20kbterms2 {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedType20kbterms2Ctrl.reportCardArray;
			vm.buckets =
				this.publishedType20kbterms2Ctrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const publishedTypeEightToTen = "publishedTypeEightToTen";
class PublishedTypeEightToTen {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		$scope.eightclass = false
		const eightclass = ["class12384"]
		$scope.isadditional = false
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeEightToTenCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeEightToTenCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			if( this.publishedTypeEightToTenCtrl.reportCardArray && Object.keys(this.publishedTypeEightToTenCtrl.reportCardArray.additional_subjects).length){
				$scope.isadditional = true
			}
			console.log(this.publishedTypeEightToTenCtrl.reportCardArray.student.class_id,"lllllllllll",eightclass)
			if(eightclass.indexOf(this.publishedTypeEightToTenCtrl.reportCardArray.student.class_id) != -1){
				$scope.eightclass = true
			}
			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeEightToTenCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeEightToTenCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeEightToTenCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeEightToTenCtrl.reportCardArray.att_values)
			this.publishedTypeEightToTenCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeEightToTenCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeEightToTenCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};



		};
	}
}
const publishedTypeEightToTen2 = "publishedTypeEightToTen2";
class PublishedTypeEightToTen2 {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.isadditional  = false;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeEightToTen2Ctrl.reportCardArray;
			vm.buckets =
			this.publishedTypeEightToTen2Ctrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
if( this.publishedTypeEightToTen2Ctrl.reportCardArray && Object.keys(this.publishedTypeEightToTen2Ctrl.reportCardArray.additional_subjects).length){
	$scope.isadditional = true
}


			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values)
			this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}

const publishedTypeSixToSeven = "publishedTypeSixToSeven";
class PublishedTypeSixToSeven {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeSixToSevenCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeSixToSevenCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};


			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixToSevenCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeSixToSevenCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeSixToSevenCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixToSevenCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixToSevenCtrl.reportCardArray.att_values)
			this.publishedTypeSixToSevenCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeSixToSevenCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixToSevenCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}
const publishedTypeSixToSeven2 = "publishedTypeSixToSeven2";
class PublishedTypeSixToSeven2 {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeSixToSeven2Ctrl.reportCardArray;
			vm.buckets =
			this.publishedTypeSixToSeven2Ctrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};

			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixToSeven2Ctrl.reportCardArray.additional_subjects;


			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values)
			this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}
const publishedTypeThreeToFive = "publishedTypeThreeToFive";
class PublishedTypeThreeToFive {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeThreeToFiveCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeThreeToFiveCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeThreeToFiveCtrl.reportCardArray.additional_subjects;



			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values)
			this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}

const publishedTypeThreeToFive2 = "publishedTypeThreeToFive2";
class PublishedTypeThreeToFive2 {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeThreeToFive2Ctrl.reportCardArray;
			console.log(vm.reportCardArray,'reportCardArray');
			vm.buckets =
			this.publishedTypeThreeToFive2Ctrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};

			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeThreeToFive2Ctrl.reportCardArray.additional_subjects;


			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values)
			this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);

			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}

const publishedTypeOneToTwo = "publishedTypeOneToTwo";
class PublishedTypeOneToTwo {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeOneToTwoCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeOneToTwoCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};

			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeOneToTwoCtrl.reportCardArray.additional_subjects;


			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeOneToTwoCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeOneToTwoCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeOneToTwoCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData
			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeOneToTwoCtrl.reportCardArray.att_values)
			this.publishedTypeOneToTwoCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeOneToTwoCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeOneToTwoCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}

const publishedTypeElevenScience = "publishedTypeElevenScience";
class PublishedTypeElevenScience {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		$scope.scienceComment = false;
		$scope.commerceComment = false;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeElevenScienceCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeElevenScienceCtrl.reportCardArray.report_card_template.activity_buckets;
			if(this.publishedTypeElevenScienceCtrl.reportCardArray.student.stream == 'Science'){
				$scope.scienceComment = true;
				$scope.commerceComment = false;
			}
			if(this.publishedTypeElevenScienceCtrl.reportCardArray.student.stream == 'Commerce'){
				$scope.commerceComment = true;
				$scope.scienceComment = false;
			}
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
		};
	}
}
const publishedTypeSixOneTwo = "publishedTypeSixOneTwo";
class PublishedTypeSixOneTwo {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];

		this.$onInit = function () {
		vm.reportCardArray =
		this.publishedTypeSixOneTwoCtrl.reportCardArray;
		vm.buckets =
		this.publishedTypeSixOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");

		self.calatt = () => {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = (presentDays / workingDays) * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixOneTwoCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee,
					"this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values)
			this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}


const publishedTypesevenOneTwo = "publishedTypesevenOneTwo";
class PublishedTypesevenOneTwo {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
				this.publishedTypesevenOneTwoCtrl.reportCardArray;
			vm.buckets =
				this.publishedTypesevenOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};

			self.checkWorkingDays = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (presentDays > workingDays) {
					toastr.error("Working days cannot be less than present days.");
					$rootScope.working_days = presentDays.toString();
				}
			}
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypesevenOneTwoCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee)


				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData



			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values)
			this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$scope.customOrderFn = function(skill) {
					const orderList = [
					  "Attitude Towards School Program and Environment",
					  "Attitude Towards Classmates",
					  "Attitude Towards Teachers",
					  "Value System"
					];
					return orderList.indexOf(skill.dimension);
				  };
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}


const publishedTypeFiveOneTwo = "publishedTypeFiveOneTwo";
class PublishedTypeFiveOneTwo {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeFiveOneTwoCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeFiveOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};


			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveOneTwoCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee,
					"this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values)
			this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}




const publishedTypeFiveEight = "publishedTypeFiveEight";
class PublishedTypeFiveEight {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {

			vm.reportCardArray =
			this.publishedTypeFiveEightCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeFiveEightCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveEightCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeFiveEightCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeFiveEightCtrl.reportCardArray.lifee,
					"this.publishedTypeFiveEightCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeFiveEightCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveEightCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveEightCtrl.reportCardArray.att_values)
			this.publishedTypeFiveEightCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeFiveEightCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveEightCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}


const publishedTypeFiveThreeFive = "publishedTypeFiveThreeFive";
class PublishedTypeFiveThreeFive {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeFiveThreeFiveCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeFiveThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveThreeFiveCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee,
					"this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values)
			this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}

const publishedTypeSixThreeFive = "publishedTypeSixThreeFive";
class PublishedTypeSixThreeFive {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeSixThreeFiveCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeSixThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			console.log(this.publishedTypeSixThreeFiveCtrl,"this.publishedTypeSixThreeFiveCtrl")
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixThreeFiveCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee,
					"this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values)
			this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}



const publishedTypeSixSixSeven = "publishedTypeSixSixSeven";
class PublishedTypeSixSixSeven {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeSixSixSevenCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeSixSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee,
					"this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values)
			this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);

				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}



const publishedTypeFiveSixSeven = "publishedTypeFiveSixSeven";
class PublishedTypeFiveSixSeven {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeFiveSixSevenCtrl.reportCardArray;
			console.log(this.publishedTypeFiveSixSevenCtrl.reportCardArray,"$onInit")
			vm.buckets =
			this.publishedTypeFiveSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log(vm.life_skills, "vm.life_skills");
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveSixSevenCtrl.reportCardArray.additional_subjects;

			self.checkWorkingDays = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (presentDays > workingDays) {
					toastr.error("Working days cannot be less than present days.");
					$rootScope.working_days = presentDays.toString();
				}
			}

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee)
				console.log(this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee,
					"this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee")

				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
					console.log(selectedDimensionn,'selectedDimensionn');
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				console.log(selectedLifeskillData,"selectedLifeskillData")
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

				console.log($rootScope.lifeskillselection,"$rootScope.lifeskillselection")

			};
			console.log(vm.selectedLifeskillValues,"vm.selectedLifeskillValues2")
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values)
			this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};
		};
	}
}
const publishedTypeThirtyKbEightNine = 'publishedTypeThirtykbEightNine'
class PublishedTypeThirtyKbEightNine {
    constructor($scope,  $state, $window, $stateParams, $sce) {
        'ngInject';
        let vm = this;
        vm.reportCardArray = undefined;
        vm.buckets = undefined;
        $scope.reportCardArray = undefined
       this.$onInit = function() {
            vm.reportCardArray = this.publishedTypeThirtyKbEightNineCtrl.reportCardArray
            vm.buckets = this.publishedTypeThirtyKbEightNineCtrl.reportCardArray.report_card_template.activity_buckets
        };
    }
}

const publishedTypeTenKbTen = 'publishedTypeTenKbTen'
class PublishedTypeTenKbTen {
    constructor($scope,  $state, $window, $stateParams, $sce) {
        'ngInject';
        let vm = this;
        vm.reportCardArray = undefined;
        vm.buckets = undefined;
        $scope.reportCardArray = undefined
       this.$onInit = function() {
            vm.reportCardArray = this.publishedTypeTenKbTenCtrl.reportCardArray
            vm.buckets = this.publishedTypeTenKbTenCtrl.reportCardArray.report_card_template.activity_buckets

        };
    }
}

const publishedTypeTenKbElevenTwelve = 'publishedTypeTenKbElevenTwelve'
class PublishedTypeTenKbElevenTwelve {
    constructor($scope,  $state, $window, $stateParams, $sce) {
        'ngInject';
        let vm = this;
        vm.reportCardArray = undefined;
        vm.buckets = undefined;
        $scope.reportCardArray = undefined
       this.$onInit = function() {
            vm.reportCardArray = this.publishedTypeTenKbElevenTwelveCtrl.reportCardArray
            vm.buckets = this.publishedTypeTenKbElevenTwelveCtrl.reportCardArray.report_card_template.activity_buckets

			$scope.isEmpty = function(obj) {
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						return false;
					}
				}
				return true;
			};


        };
    }
}

const publishedTypeTwelveScience = "publishedTypeTwelveScience";
class PublishedTypeTwelveScience {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		$scope.scienceComment = false;
		$scope.commerceComment = false;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray =
			this.publishedTypeTwelveScienceCtrl.reportCardArray;
			vm.buckets =
			this.publishedTypeTwelveScienceCtrl.reportCardArray.report_card_template.activity_buckets;
			if(this.publishedTypeTwelveScienceCtrl.reportCardArray.student.stream == 'Science'){
				$scope.scienceComment = true;
				$scope.commerceComment = false;
			}
			if(this.publishedTypeTwelveScienceCtrl.reportCardArray.student.stream == 'Commerce'){
				$scope.commerceComment = true;
				$scope.scienceComment = false;
			}

			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
		};
	}
}
const typePtNoConv = "typePtNoConv";
class TypePtNoConv {
	constructor($scope, $state, $window, $stateParams, $sce) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		$scope.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.typePtNoConvCtrl.reportCardArray;
			vm.buckets =
				this.typePtNoConvCtrl.reportCardArray.report_card_template.activity_buckets;
		};
	}
}
const montessoryConsolidate = "montessoryConsolidate";
class MontessoryConsolidated {
	constructor($scope, $state, $window, $stateParams, $sce,$rootScope) {
		"ngInject";

		let vm = this;
		vm.reportCardArray = undefined;
		this.$onInit = function () {
			vm.reportCardArray = this.montessoryConsolidatedCtrl.reportCardArray;
			vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
			vm.reportResultArray =
				vm.reportCardArray.reportCardArray.main_result_report;
		};
	}
}
const termoneTemplatepublishedTypeFiveThreeFive = "termoneTemplatepublishedTypeFiveThreeFive";
class TermOneTemplatePublishedTypeFiveThreeFive {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray;
			vm.buckets = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			console.log($rootScope.published_date)
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values)
			this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}
const termoneTemplatepublishedTypeSixSixSeven = "termoneTemplatepublishedTypeSixSixSeven";
class TermOneTemplatePublishedTypeSixSixSeven {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray;
			vm.buckets = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects;
			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values)
			this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}

const termoneTemplatepublishedTypeEightNine = "termoneTemplatepublishedTypeEightNine"
class TermOneTemplatePublishedTypeEightNine {
	constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray;
			vm.buckets = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {
				orderByDimension(this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values)
			this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});

			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}

const termoneTemplatepublishedTypeOneTwo = "termoneTemplatepublishedTypeOneTwo"
class TermOneTemplatePublishedTypeOneTwo{
constructor($scope, $state, $window, $stateParams, $sce, $rootScope) {
		"ngInject";
		let vm = this;
		vm.reportCardArray = undefined;
		vm.buckets = undefined;
		vm.life_skills = undefined;
		vm.att_values = undefined;
		$scope.reportCardArray = undefined;
		$scope.life_skills = undefined;
		$scope.att_values = undefined;
		$scope.selectedDescription = [];
		this.$onInit = function () {
			vm.reportCardArray = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray;
			vm.buckets = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			self.calatt = () => {
				var workingDays = Number($rootScope.working_days);
				var presentDays = Number($rootScope.days_attended);
				if (workingDays < presentDays) {
					$rootScope.days_attended = '';
					toastr.error("Working days cannot be less than present days.");
				} else {
					var attVal = (presentDays / workingDays) * 100;
					$rootScope.attendance_term1 = Math.round(attVal);
					$scope.$apply();
				}
			};
			$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.additional_subjects;

			function orderByDimension(array) {
				return array.sort(function (a, b) {
					if (a.dimension < b.dimension) {
						return -1;
					}
					if (a.dimension > b.dimension) {
						return 1;
					}
					return 0;
				});
			}
			$scope.saveSelectedValuesOne = function (index) {


				orderByDimension(this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee)
				var selectedLevel = $rootScope.lifeskillselection[index].level;

				var selectedDescription =
					this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee[index]
						.dimension;
					var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
                $rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
                $rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

				 $rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData

			};
			$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values)
			this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values.sort((a, b) => a.order - b.order);
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription =
					this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values[
						index
					].levels.find(function (level) {
						return level.level === selectedLevel;
					}).description;
				var selectedDimension =
					this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values[index]
						.dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription,
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			};
			$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map((skill, index) => {
				const orderList = [
					"Attitude Towards School Program and Environment",
					"Attitude Towards Classmates",
					"Attitude Towards Teachers",
					"Value System"
				];
				const orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});
			$scope.customOrderFn = function(skill) {
				return skill.order;
			};

		};
	}
}
export default angular
	.module(name, [])
	.component(name, {
		template: templateMain,
		controllerAs: "publishedReportsListCtrl",
		controller: PublishedReportsListCtrl,
	})
	.component(typeOneHfYComponent, {
		template: typeOneHfYTemplate,
		transclude: true,
		require: {
			typeOneHfYTemplateCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeOneHfYTemplateCtrl",
		controller: TypeOneHfYTemplateClass,
	})
	.component(periodicTestDefaultHfPublished, {
		template: periodicTestDeafaultHFTemplate,
		transclude: true,
		require: {
			pTPublishedDefauHlFCtrl: "^reportsMainComponent",
		},
		controllerAs: "pTHFCtrl",
		controller: PeriodicTestDefaultHfPublished,
	})
	.component(periodicTestDefaultAnnualPublished, {
		template: periodicTestDeafaultANNUALTemplate,
		transclude: true,
		bindings: true,
		require: {
			pTPublishedDefaultAnnualCtrl: "^reportsMainComponent",
		},
		controllerAs: "pTAnnualCtrl",
		controller: PeriodicTestDefaultAnnualPublished,
	})
	.component(defaultYearEnd, {
		template: defaultYearEndTemplate,
		transclude: true,
		bindings: true,
		require: {
			defaultYearEndCtrl: "^reportsMainComponent",
		},
		controllerAs: "defaultYearEndCtrl",
		controller: DefaultYearEnd,
	})
	.component(termConsolidated, {
		template: termConsolidatedTemplate,
		transclude: true,
		bindings: true,
		require: {
			termConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "termConsolidatedCtrl",
		controller: TermConsolidated,
	})
	.component(educoreYearEnd, {
		template: educoreYearEndTemplate,
		transclude: true,
		bindings: true,
		require: {
			educoreYearEndCtrl: "^reportsMainComponent",
		},
		controllerAs: "educoreYearEndCtrl",
		controller: EducoreYearEnd,
	})
	.component(skilSubSkill, {
		template: skilSubSkillTemplate,
		transclude: true,
		bindings: true,
		require: {
			skilSubSkillCtrl: "^reportsMainComponent",
		},
		controllerAs: "skilSubSkillCtrl",
		controller: SkilSubSkill,
	})
	.component(assetHF, {
		template: assetHFTemplate,
		transclude: true,
		bindings: true,
		require: {
			assetHFCtrl: "^reportsMainComponent",
		},
		controllerAs: "assetHFCtrl",
		controller: AssetHF,
	})
	.component(assetAnnual, {
		template: assetAnnualemplate,
		transclude: true,
		bindings: true,
		require: {
			assetAnnualCtrl: "^reportsMainComponent",
		},
		controllerAs: "assetAnnualCtrl",
		controller: AssetAnnual,
	})
	.component(periodicTestDefaultHfTwoPublished, {
		template: pTPublishedDefaultHFTwoTemplate,
		transclude: true,
		require: {
			pTPublishedHfTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "ptHfTwoCtrl",
		controller: PeriodicTestDefaultHfTwoPublished,
	})
	.component(periodicTestDefaultAnnualTwoPublished, {
		template: periodicTestDefaultAnnualTwoTemplate,
		transclude: true,
		require: {
			pTPublishedDefaultAnnualTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "ptAnnualTwoCtrl",
		controller: PeriodicTestDefaultAnnualTwoPublished,
	})
	.component(kgTerms, {
		template: kgTermsTemplate,
		transclude: true,
		bindings: true,
		require: {
			kgTermsCtrl: "^reportsMainComponent",
		},
		controllerAs: "kgTermsCtrl",
		controller: KgTerms,
	})
	.component(kgConsolidated, {
		template: kgConsolidatedTemplate,
		transclude: true,
		bindings: true,
		require: {
			kgConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "kgConsolidatedCtrl",
		controller: KgConsolidated,
	})
	.component(kbTerms, {
		template: kbTermsTemplate,
		transclude: true,
		bindings: {
			attendance: "@",
		},
		require: {
			kbTermsCtrl: "^reportsMainComponent",
		},
		controllerAs: "kbTermsCtrl",
		controller: KbTerms,
	})
	.component(hssTemplateComponent, {
		template: hssTemplate,
		transclude: true,
		bindings: true,
		require: {
			hssReportCtrl: "^reportsMainComponent",
		},
		controllerAs: "hssReportCtrl",
		controller: HssTemplateComponentClass,
	})
	.component(cbseHssPublishedComponent, {
		template: cbsehssTemplate,
		transclude: true,
		bindings: true,
		require: {
			cbseHssPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "cbseHssPublishedCtrl",
		controller: CbseHssPublishedClass,
	})
	.component(specificHFComponent, {
		template: specificHalfYearlyTemplate,
		transclude: true,
		bindings: true,
		require: {
			specificHFPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "specificHFPublishedCtrl",
		controller: SpecificHFPublishedClass,
	})
	.component(kbhfhssComp, {
		template: kb_hf_hssTemplate,
		transclude: true,
		bindings: true,
		require: {
			KbhfhssPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "KbhfhssPublishedCtrl",
		controller: KbhfhssPublishedClass,
	})
	.component(cbseSpecificSubjectsFinalComp, {
		template: cbseSpecificSubjectsFinalTemplate,
		transclude: true,
		bindings: true,
		require: {
			cbseSpecificSubjectsFinalCtrl: "^reportsMainComponent",
		},
		controllerAs: "cbseSpecificSubjectsFinalCtrl",
		controller: CbseSpecificSubjectsFinalClass,
	})
	.component(cbseSpecificoneeigthFinalComp, {
		template: grade1_8AnnTemplate,
		transclude: true,
		bindings: true,
		require: {
			cbseSpecificoneeghtFinalCtrl: "^reportsMainComponent",
		},
		controllerAs: "cbseSpecificoneeghtFinalCtrl",
		controller: CbseSpecificoneeigthFinalClass,
	})
	.component(kbFinalComponent, {
		template: kbfinalTemplate,
		transclude: true,
		bindings: true,
		require: {
			kbFinalComponentCtrl: "^reportsMainComponent",
		},
		controllerAs: "kbFinalComponentCtrl",
		controller: kbFinalComponentClass,
	})
	.component(pubishedcbsehssAnnual, {
		template: annualcbsehssTemplate,
		transclude: true,
		bindings: true,
		require: {
			pubishedcbsehssAnnualCtrl: "^reportsMainComponent",
		},
		controllerAs: "pubishedcbsehssAnnualCtrl",
		controller: PubishedcbsehssAnnual,
	})
	.component(nineonlypubllishedComp, {
		template: nineAnnualOnlyTemplate,
		transclude: true,
		bindings: true,
		require: {
			nineonlypubllishedCompCtrl: "^reportsMainComponent",
		},
		controllerAs: "nineonlypubllishedCompCtrl",
		controller: NineonlypubllishedCompClass,
	})
	.component(kbannualHssPublished, {
		template: kb_hss_annualTemplate,
		transclude: true,
		bindings: true,
		require: {
			kbannualHssPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "kbannualHssPublishedCtrl",
		controller: KbannualHssPublishedClass,
	})
	.component(montessoryTerms, {
		template: montessoryTermsTemplate,
		transclude: true,
		bindings: true,
		require: {
			montessoryTermsPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "montessoryTermsPublishedCtrl",
		controller: montessoryTermsPublishedClass,
	})
	.component(montessoryConsolidated, {
		template: montessoryConsolidateTemplate,
		transclude: true,
		bindings: true,
		require: {
			montessoryConsolidatedPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "montessoryConsolidatedPublishedCtrl",
		controller: montessoryConsolidatedPublishedClass,
	})
	.component(kbhfPtPublishedComponent, {
		template: pTHFKb_Template,
		transclude: true,
		bindings: true,
		require: {
			kbhfPtPublishedPublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "kbhfPtPublishedPublishedCtrl",
		controller: KbhfPtPublishedPublishedClass,
	})
	.component(hfexamOnePublishedComponent, {
		template: publishedHFEXAM_CALICUT_Template,
		transclude: true,
		bindings: true,
		require: {
			hfexamOnePublishedCtrl: "^reportsMainComponent",
		},
		controllerAs: "hfexamOnePublishedCtrl",
		controller: HfexamOnePublishedComponentClass,
	})
	.component(publishedCbseTypefiveNineTen, {
		template: publishedType5_9_10_template,
		transclude: true,
		bindings: true,
		require: {
			publishedCbseTypefiveNineTenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedCbseTypefiveNineTenCtrl",
		controller: PublishedCbseTypefiveNineTenClass,
	})
	.component(publishedTypeFiveKbten, {
		template: publishedType5_KB_10_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveKbtenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveKbtenCtrl",
		controller: PublishedTypeFiveKbtenClass,
	})
	.component(publishedTypeFiveSixEight, {
		template: publishedType5_6_8_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveSixEightCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveSixEightCtrl",
		controller: PublishedTypeFiveSixEight,
	})
	.component(publishedTypeFiveOneFive, {
		template: publishedType5_1_5_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveOneFiveCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveOneFiveCtrl",
		controller: PublishedTypeFiveOneFive,
	})
	.component(publishedTypeFiveKbEightNine, {
		template: publishedType5_8_9_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveKbEightNineCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveKbEightNineCtrl",
		controller: PublishedTypeFiveKbEightNine,
	})
	.component(publishedTypeSixModalExamTermOne, {
		template: publishedtype_6modelexam1_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixModalExamTermOneCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixModalExamTermOneCtrl",
		controller: PublishedTypeSixModalExamTermOne,
	})
	.component(typesixModelExamTermOneninetenPublished, {
		template: publishedtypetype_6_model_exam_1nineten_template,
		transclude: true,
		bindings: true,
		require: {
			typesixModelExamTermOneninetenPublishedCtrl:
				"^reportsMainComponent",
		},
		controllerAs: "typesixModelExamTermOneninetenPublishedCtrl",
		controller: TypesixModelExamTermOneninetenPublished,
	})
	.component(typesixModelExamTermTwoninetenPublished, {
		template: publishedtypetype_6_model_exam_IInineten_template,
		transclude: true,
		bindings: true,
		require: {
			typesixModelExamTermTwoninetenPublishedCtrl:
				"^reportsMainComponent",
		},
		controllerAs: "typesixModelExamTermTwoninetenPublishedCtrl",
		controller: TypesixModelExamTermTwoninetenPublished,
	})
	.component(publishedTypeSixModalExamTermTwonospace, {
		template: publishedtype_6modelexam2_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixModalExamTermTwonospaceCtrl:
				"^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixModalExamTermTwonospaceCtrl",
		controller: PublishedTypeSixModalExamTermTwonospace,
	})
	.component(publishedTypeSixModelannualexam, {
		template: publishedtype_6modelannualexam2_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixModelannualexamCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixModelannualexamCtrl",
		controller: PublishedTypeSixModelannualexam,
	})
	.component(publishedTypeSevenCalicutAnnualexam, {
		template: publishedtype_seven_calicut_annual,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSevenCalicutAnnualexamCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSevenCalicutAnnualexamCtrl",
		controller: PublishedTypeSevenCalicutAnnualexam,
	})
	.component(kgthematictermsComponent, {
		template: kgthematictermsTemplate,
		transclude: true,
		bindings: true,
		require: {
			kgthematictermsCtrl: "^reportsMainComponent",
		},
		controllerAs: "kgthematictermsCtrl",
		controller: KgthematictermsClass,
	})
	.component(typeNineCbseConsolidated, {
		template: type9cbse11Template,
		transclude: true,
		bindings: true,
		require: {
			typeNineCbseConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeNineCbseConsolidatedCtrl",
		controller: TypeNineCbseConsolidated,
	})
	.component(typeNineCbsept, {
		template: type9_cbse_pt1Template,
		transclude: true,
		bindings: true,
		require: {
			typeNineCbseptCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeNineCbseptCtrl",
		controller: TypeNineCbsept,
	})
	.component(typeNineTwelveCbseConsolidated, {
		template: type9_grade12term2_aeTemplate,
		transclude: true,
		bindings: true,
		require: {
			typeNineTwelveCbseConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeNineTwelveCbseConsolidatedCtrl",
		controller: TypeNineTwelveCbseConsolidated,
	})
	.component(typeNinekbUnitTest, {
		template: type9_kb_unit_test1_template,
		transclude: true,
		bindings: true,
		require: {
			typeNinekbUnitTestCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeNinekbUnitTestCtrl",
		controller: TypeNinekbUnitTest,
	})
	.component(typeNinekbConsolidated, {
		template: type9_kbterm3_template,
		transclude: true,
		bindings: true,
		require: {
			typeNinekbConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "typeNinekbConsolidatedCtrl",
		controller: TypeNinekbConsolidated,
	})
	.component(publishedTypeTwelveOneEight, {
		template: type12_termcbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwelveOneEightCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwelveOneEightCtrl",
		controller: PublishedTypeTwelveOneEight,
	})
	.component(publishedTypeTwelveNineTen, {
		template: publishedTypeTwelveNineTenTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwelveNineTenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwelveNineTenCtrl",
		controller: PublishedTypeTwelveNineTen,
	})
	.component(publishedEltReport, {
		template: eltReportTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedEltReportCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedEltReportCtrl",
		controller: PublishedEltReport,
	})
	.component(publishedType20kbterms, {
		template: type20_KB_10_grade_term1Temp,
		transclude: true,
		bindings: true,
		require: {
			publishedType20kbtermsCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedType20kbtermsCtrl",
		controller: PublishedType20kbterms,
	})
	.component(publishedTypeTwentyNineTen, {
		template: type20_termcbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwentyNineTenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwentyNineTenCtrl",
		controller: PublishedTypeTwentyNineTen,
	})
	.component(publishedTypeTwentyOneEight, {
		template: type20_termcbse18Template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwentyOneEightCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwentyOneEightCtrl",
		controller: PublishedTypeTwentyOneEight,
	})
	.component(publishedType20kbterms2, {
		template: type20_KB_10_grade_term2Temp,
		transclude: true,
		bindings: true,
		require: {
			publishedType20kbterms2Ctrl: "^reportsMainComponent",
		},
		controllerAs: "publishedType20kbterms2Ctrl",
		controller: PublishedType20kbterms2,
	})
	.component(publishedTypeTwentyNineTenTwo, {
		template: type20_term2cbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwentyNineTenTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwentyNineTenTwoCtrl",
		controller: PublishedTypeTwentyNineTenTwo,
	})
	.component(publishedTypeTwentyOneEightTwo, {
		template: type20_term2cbse18Template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwentyOneEightTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwentyOneEightTwoCtrl",
		controller: PublishedTypeTwentyOneEightTwo,
	})
	.component(publishedTypeFiveSixSeven, {
		template: publishedType5_6_7_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveSixSevenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveSixSevenCtrl",
		controller: PublishedTypeFiveSixSeven,
	})
	.component(publishedTypeSixSixSeven, {
		template: publishedType6_6_7_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixSixSevenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixSixSevenCtrl",
		controller: PublishedTypeSixSixSeven,
	})
	.component(publishedTypeSixThreeFive, {
		template: publishedType6_3_5_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixThreeFiveCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixThreeFiveCtrl",
		controller: PublishedTypeSixThreeFive,
	})

	.component(publishedTypeFiveOneTwo, {
		template: publishedType5_1_2_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveOneTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveOneTwoCtrl",
		controller: PublishedTypeFiveOneTwo,
	})
	.component(publishedTypeSixOneTwo, {
		template: publishedType6_1_2_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixOneTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixOneTwoCtrl",
		controller: PublishedTypeSixOneTwo,
	})
	.component(publishedTypeFiveEight, {
		template: publishedType5_8_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveEightCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveEightCtrl",
		controller: PublishedTypeFiveEight,
	})
	.component(publishedTypeFiveThreeFive, {
		template: publishedType5_3_5_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeFiveThreeFiveCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeFiveThreeFiveCtrl",
		controller: PublishedTypeFiveThreeFive,
	})
	.component(publishedTypeEightToTen, {
		template: type8to10_termcbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeEightToTenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeEightToTenCtrl",
		controller: PublishedTypeEightToTen,
	})
	.component(publishedTypeEightToTen2, {
		template: typetermcbse_8to10Template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeEightToTen2Ctrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeEightToTen2Ctrl",
		controller: PublishedTypeEightToTen2,
	})
	.component(publishedTypeSixToSeven, {
		template: type6to7_alncbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixToSevenCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixToSevenCtrl",
		controller: PublishedTypeSixToSeven,
	})
	.component(publishedTypeSixToSeven2, {
		template: type6to7_tcscbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeSixToSeven2Ctrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeSixToSeven2Ctrl",
		controller: PublishedTypeSixToSeven2,
	})
	.component(publishedTypeThreeToFive, {
		template: type3to5_tcscbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeThreeToFiveCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeThreeToFiveCtrl",
		controller: PublishedTypeThreeToFive,
	})
	.component(publishedTypeThreeToFive2, {
		template: type3to5_alncbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeThreeToFive2Ctrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeThreeToFive2Ctrl",
		controller: PublishedTypeThreeToFive2,
	})
	.component(publishedTypeOneToTwo, {
		template: type1to2_tcscbseTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeOneToTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeOneToTwoCtrl",
		controller: PublishedTypeOneToTwo,
	})


	.component(publishedTypesevenOneTwo, {
		template: publishedType7_1_2_template,
		transclude: true,
		bindings: true,
		require: {
			publishedTypesevenOneTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypesevenOneTwoCtrl",
		controller: PublishedTypesevenOneTwo,
	})
	.component(publishedTypeThirtyKbEightNine, {
        template: type30_KB_8_9_grade_term3Template,
        transclude: true,
        bindings : true,
        require: {
            publishedTypeThirtyKbEightNineCtrl : '^reportsMainComponent'
        },
        controllerAs: "publishedTypeThirtyKbEightNineCtrl",
        controller: PublishedTypeThirtyKbEightNine
    }).component(publishedTypeTenKbTen, {
		template: type10_KB_10_grade_term1Template,
		transclude: true,
		bindings : true,
		require: {
			publishedTypeTenKbTenCtrl : '^reportsMainComponent'
		},
		controllerAs: "publishedTypeTenKbTenCtrl",
		controller: PublishedTypeTenKbTen
	}).component(publishedTypeTenKbElevenTwelve, {
		template: type10_KB_11_12_grade_term1Template,
		transclude: true,
		bindings : true,
		require: {
			publishedTypeTenKbElevenTwelveCtrl : '^reportsMainComponent'
		},
		controllerAs: "publishedTypeTenKbElevenTwelveCtrl",
		controller: PublishedTypeTenKbElevenTwelve
	}).component(publishedTypeElevenScience, {
		template: type02grade_11_scienceTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeElevenScienceCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeElevenScienceCtrl",
		controller: PublishedTypeElevenScience,
	}).component(publishedTypeTwelveScience, {
		template: type02grade_12_scienceTemplate,
		transclude: true,
		bindings: true,
		require: {
			publishedTypeTwelveScienceCtrl: "^reportsMainComponent",
		},
		controllerAs: "publishedTypeTwelveScienceCtrl",
		controller: PublishedTypeTwelveScience,
	})
	.component(typePtNoConv, {
		template: pt_1_no_convTemplate,
		transclude: true,
		bindings: true,
		require: {
			typePtNoConvCtrl: "^reportsMainComponent",
		},
		controllerAs: "typePtNoConvCtrl",
		controller: TypePtNoConv,
	}).component(montessoryConsolidate, {
		template: montessoryConsolidateTemplate,
		transclude: true,
		bindings: true,
		require: {
			montessoryConsolidatedCtrl: "^reportsMainComponent",
		},
		controllerAs: "montessoryConsolidatedCtrl",
		controller: MontessoryConsolidated,
	})
	.component(termoneTemplatepublishedTypeFiveThreeFive, {
		template: term1TemplatepublishedType5_3_5_template,
		transclude: true,
		bindings: true,
		require: {
			termOneTemplatepublishedTypeFiveThreeFiveCtrl: "^reportsMainComponent",
		},
		controllerAs: "termOneTemplatepublishedTypeFiveThreeFiveCtrl",
		controller: TermOneTemplatePublishedTypeFiveThreeFive,
	})

	.component("termoneTemplatepublishedTypeSixSixSeven", {
		template: term1TemplatepublishedType6_6_7_template,
		transclude: true,
		bindings: true,
		require: {
			termOneTemplatepublishedTypeSixSixSevenCtrl: "^reportsMainComponent",
		},
		controllerAs: "termOneTemplatepublishedTypeSixSixSevenCtrl",
		controller: TermOneTemplatePublishedTypeSixSixSeven,
	})


	.component("termoneTemplatepublishedTypeEightNine", {
		template:term1TemplatepublishedType8_9template,
		transclude: true,
		bindings: true,
		require: {
			termOneTemplatepublishedTypeEightNineCtrl: "^reportsMainComponent",
		},
		controllerAs: "termOneTemplatepublishedTypeEightNineCtrl",
		controller: TermOneTemplatePublishedTypeEightNine,
	})
	.component("termoneTemplatepublishedTypeOneTwo", {
		template:term1TemplatepublishedType1_2template,
		transclude: true,
		bindings: true,
		require: {
			termOneTemplatepublishedTypeOneTwoCtrl: "^reportsMainComponent",
		},
		controllerAs: "termOneTemplatepublishedTypeOneTwoCtrl",
		controller: TermOneTemplatePublishedTypeOneTwo,
	})
	.constant("rcConstants", {
		_NOT_APPLICABLE: "NA",
		ABSENT: "ABSENT",
		TYPE_1_MARK: "type-1-mark",
		TYPE_1_DEFAULT_ANNUAL: "type-1-annual",
		TYPE_1_GRADE: "type-1-grade",
		TYPE_2_MARK: "type-2-mark",
		TYPE_SKILL_ONLY: "skill_only",
		TYPE_3_SUB_SLILL: "type-3-sub_skill",
		DEFAULT_PERIODICTEST_HF: "periodic-test-hf",
		DEFAULT_PERIODICTEST_ANNUAL: "periodic-test-annual",
		_CO_SCHOLASTIC_NAME: "Co-scholastic",
		GRADE_BASED_SUBJECT_PACKAGES: ["Co-scholastic"],
		DEFAULT_REPORTCARD_PT_HF_TWO: "Periodic Test-II-Half Yearly",
		DEFAULT_REPORTCARD_PT_ANNUAL_TWO: "Periodic Test-II-Annual",
		REPORT_CARDS_PERIODIC_TEST: [
			"Periodic Test-Half Yearly",
			"Periodic Test-II-Half Yearly",
			"Periodic Test-Annual",
			"Periodic Test-II-Annual",
		],
		DEFAULT_REPORTCARDS: [
			"Annual",
			"Half Yearly",
			"Periodic Test-Half Yearly",
			"Periodic Test-Annual",
			"Periodic Test-II-Half Yearly",
			"Periodic Test-II-Annual",
		],
		DEFAULT_ANUAL_REPORTCARD: "Annual",
		DEFAULT_REPORTCARD_PT_ANNUAL: "Periodic Test-Annual",
		DEFAULT_REPORTCARD_PT_HF: "Periodic Test-Half Yearly",
		DEFAULT_PERIODICTEST_HF_TWO: "periodic-test-hf-2",
		DEFAULT_PERIODICTEST_ANNUAL_TWO: "periodic-test-annual-two",
		DEFAULT_HF_REPORTCARD: "Half Yearly",
		DEFAULT_REPORT_CARDS_FOR_YEAREND: ["Annual", "Half Yearly"],
		DEFAULT_YEAR_END: "default-year-end",
		EDUCORE_YEAR_END: "educore-year-end",
		EVALUATION_RC: ["Evaluation-3", "Evaluation-2", "Evaluation-1"],
		EVAL_ONE_RC: "Evaluation-1",
		EVAL_TWO_RC: "Evaluation-2",
		EVAL_THREE_RC: "Evaluation-3",
		ASSET_ME_RC_HALF: ["Term 1"],
		ASSET_ME_RC_HALF_NAME: "Term 1",
		ASSET_ME_RC_ANNUAL_NAME: "Term 2",
		ASSET_ME_RC_NAMES: ["Term 1", "Term 2"],
		TYPE_4_MARK: "type-4-mark",
		TYPE_4_ANNUAL: "type-4-annual",
		ASSET_CONSOLIDATED: "term1-term2",
		KG_CARDS: ["KG-Term-1", "KG-Term-2", "KG-Term-3"],
		KB_CARDS: ["KB-Term-1", "KB-Term-2", "KB-Term-3"],
		MONTESSORY_CARDS: [
			"MONTESSORI-Term-I",
			"MONTESSORI-Term-II",
			"MONTESSORI-Term-III",
		],
		KG_TERM: "kg-term",
		KG_TERMS: "kg-terms",
		KB_TERMS: "kb-terms",
		MONTESSORY_TERMS: "montessory",
		MONTESSORY_CONSOLIDATED: "montessory-consolidated",
		KG_CONSOLIDATED: "kg-consolidated",
		HIGHER_SECONDARY_REPORT: "hss-template",
		CBSE_HSHF: "cbse_hss",
		NON_FINAL_SCHOOL_IDS: ["m2LMtqaESFZf6xDE8", "ps4vyLJhQvPZjfxaH"],
		MEP_STATIC_SCHOOL_IDS: ["ps4vyLJhQvPZjfxaH"],
	})
	.controller("reportsMainComponent", PublishedReportsListCtrl);

function config($stateProvider) {
	"ngInject";
	$stateProvider.state("reportsMain", {
		url: "/view-report/:student_id/:console_id/:type/:template_view/:asset_format/:selected_year/:kb_consolidated/:kg_consolidated/:montessori_consolidated:for_ct",
		template: "<reports-main-component></reports-main-component>",
	});
}



// WEBPACK FOOTER //
// ./src/app/report_cards/student/publishedModule.js